"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-attention-filled-16><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v3Z"></path></symbol>';
}
